import { useContext, useMemo } from 'react'

import { Dropdown } from 'core-components/library/dropdown'
import { SIZE_SELECTOR_DATA } from 'core-components/sitebuilder/layout/context/constants/sizeSelector'
import { TSizeSelectorLabel } from 'core-components/sitebuilder/layout/context/models/ISizeSelector'
import { SiteBuilderContext } from 'core-components/sitebuilder/layout/context/SiteBuilderContext'
import { BaseCrud, Static } from 'core-components/types'

interface ISizeSelector {
  value: string
  onChange: (newValue: string) => void
  label: TSizeSelectorLabel
}

export const SizeSelector = ({ value, onChange, label }: ISizeSelector) => {
  const { settingsLayout } = useContext(SiteBuilderContext)

  const source = useMemo(() => {
    const data = settingsLayout?.selectorData?.sizeSelector || SIZE_SELECTOR_DATA
    const crud = new BaseCrud({
      fetcher: new Static(data),
      keyField: 'id',
    })
    crud.setPaging({
      page: 0,
      pageSize: 100,
    })
    return crud
  }, [])

  return (
    <Dropdown
      source={source}
      caption={'label'}
      onChange={onChange}
      value={value}
      label={`Select ${label} size`}
    />
  )
}
